import React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { AppState, IPageState } from '../../appredux'
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Trans } from 'react-i18next';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import { DialogContentText } from '@material-ui/core';
import SymulacjaPlatnosci from './SymulacjaPlatnosci';
import CONFIG from '../../cfg/config';
import axios from 'axios';

//PM 2021-10-26
//wstrzykniecie tylko uzywanych pol z magazynu dancyh
type ModalProps = {
  platnosciOpen: number,
  numerRezerwacji: number,
  kwota: number
}

type ModalState = {
  open: boolean,
  open2: boolean,
  open3: boolean,
  platnosc: boolean

}

//const secondaryLight = theme.palette.secondary.light;

class NotifierOptions extends React.Component<ModalProps & WithStyles<typeof styles>, ModalState> {

  state = {
    open: false,
    open2: false,
    open3: false,
    platnosc: false
    
  };

//PM 2021-10-26
//wstrzykniecie tylko uzywanych pol z magazynu dancyh
  componentDidUpdate(prevProps: ModalProps) {
    if (this.props.platnosciOpen !== prevProps.platnosciOpen)
      this.setState({ ...this.state, open: true });
  }

    back = () => {
        this.setState({ open: false })
    }

    next = () => {
        this.setState({ open: false, open2: true, open3: false })
    }

    //PM 2021-10-26
//wstrzykniecie tylko uzywanych pol z magazynu dancyh
    failure = async () => {
        this.setState({ open2: false, open3: true, platnosc: false })
        try {
            await axios.get("https://vsc24.net/vscHotelBook/manager/recepcjaPobytAnuluj?hotelId=" +  CONFIG.hotelID + "&aOperatorId=" + Number(sessionStorage.getItem("operator_id")) + "&aPobytId=" + this.props.numerRezerwacji)
      
            // if (this.props.pay_web === '4') {
            //   if (this.props.onPrzelewy24Success)
            //     await this.props.onPrzelewy24Success()
            // }
          } catch (error) {
            console.log(error)
          }
    }

    //PM 2021-10-26
//wstrzykniecie tylko uzywanych pol z magazynu dancyh
    success = async () => {

        this.setState({ open2: false, open3: true, platnosc: true })
        try {
            await axios.get("https://vsc24.net/vscHotelBook/manager/recepcjaPobytPotwierdz?hotelId=" +  CONFIG.hotelID + "&aOperatorId=" + Number(sessionStorage.getItem("operator_id")) + "&aPobytId=" + this.props.numerRezerwacji)
      
            // if (this.props.pay_web === '4') {
            //   if (this.props.onPrzelewy24Success)
            //     await this.props.onPrzelewy24Success()
            // }
          } catch (error) {
            console.log(error)
          }
    }

  //PM 2021-10-26
//wstrzykniecie tylko uzywanych pol z magazynu dancyh
  render() {
    const classes = this.props.classes;
   


    return (
        <>
      <Dialog
        disableEscapeKeyDown
        maxWidth="sm"
        open={this.state.open}
      >
        <DialogTitle disableTypography>
          <Typography variant="h6" component="h2" color="secondary">
            <b>Info</b>
          </Typography>
          <hr />
        </DialogTitle>

        <DialogContent className={classes.dialogContent}>
            <DialogContentText /*color="primary"*/ style={{ fontSize: "1rem" }}>
                {"Symulacja płatności internetowej"}
            </DialogContentText>
            <DialogContentText /*color="primary"*/ style={{ fontSize: "1rem" }}>
                {"Kwota: " + this.props.kwota }
            </DialogContentText>
            <DialogContentText /*color="primary"*/ style={{ fontSize: "1rem"}}>
                {"Vsc_ident: " + this.props.numerRezerwacji}
            </DialogContentText>
            <DialogContentText /*color="primary"*/ style={{ fontSize: "1rem"}}>
                {"Sukces: https://vsc24.net/vscHotelBook/manager/recepcjaPobytPotwierdz?hotelId=" +  CONFIG.hotelID + "&aOperatorId=" + Number(sessionStorage.getItem("operator_id")) + "&aPobytId=" + this.props.numerRezerwacji}
            </DialogContentText>
            <DialogContentText /*color="primary"*/ style={{ fontSize: "1rem"}}>
                {"Porażka: https://vsc24.net/vscHotelBook/manager/recepcjaPobytAnuluj?hotelId=" +  CONFIG.hotelID + "&aOperatorId=" + Number(sessionStorage.getItem("operator_id")) + "&aPobytId=" + this.props.numerRezerwacji}
            </DialogContentText>
            



         
        </DialogContent>
        <DialogActions >
          <Button onClick={this.back}
            variant="outlined" color="secondary" size="small"
            style={{ textTransform: "lowercase" }}>
            <b><Trans>Back</Trans></b>
          </Button>
          <Button onClick={this.next}
            variant="contained" color="secondary" size="small"
            style={{ textTransform: "lowercase" }}>
            <b><Trans>Next</Trans></b>
          </Button>
        </DialogActions>
        {/* </div> */}
      </Dialog>
      {/* //////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
      <Dialog
        disableEscapeKeyDown
        maxWidth="xs"
        open={this.state.open2}
      >
         <DialogTitle disableTypography>
          <Typography variant="h6" component="h2" color="secondary">
            <b>Wybierz</b>
          </Typography>
          <hr />
        </DialogTitle>  
        <DialogContent className={classes.dialogContent}>
            <DialogContentText /*color="primary"*/ style={{ fontSize: "1rem" }}>
                {`Wybierz "sukces", aby zakończyć transakcję sukcesem`}
            </DialogContentText>
            <DialogContentText /*color="primary"*/ style={{ fontSize: "1rem" }}>
                {`Wybierz "niepowodzenie", aby zakończyć transakcję niepowodzeniem` }
            </DialogContentText>
        </DialogContent>    
            
        <DialogActions>
          <Button variant="outlined" size="small" onClick={this.success} //target="_blank" href="/vscHotelBook/hotel/success" 
            style={{ color: '#458B00' }}>
            <b>sukces</b>
          </Button>
          <Button variant="outlined" size="small" onClick={this.failure} //target="_blank" href="/vscHotelBook/hotel/failure" 
            style={{ color: '#3a87ad' }}>
            <b>niepowodzenie</b>
          </Button>
        </DialogActions>
      </Dialog>

      <SymulacjaPlatnosci platnosc={this.state.open3} success={this.state.platnosc} />
      </>
    );
  }
}

const styles = (theme: Theme) => ({
  headline: {
    fontFamily: "\"'Open Sans'\", sans-serif",
    lineHeight: "20px",
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "0px"
  },
  secondary: {
    color: theme.palette.secondary.main
  },
  alert: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: '#ffffff',
    padding: "42px 70px 42px 70px",
    maxWidth: "727px",
    outline: 0
  },
  textField: {
    marginLeft: "6px",
    //marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  black: {
    color: "rgb(0, 0, 0)",
    backgroundColor: "inherit",
    textAlign: 'left' as 'left',
  },
  label: {
    //fontFamilly: "sans-serif",
    //fontSize: "small"
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight,
    padding: "7px 0 4px"
  },
  dialogContent: {
    paddingTop: 0
  }
});

const mapStateToProps = (state: AppState) => ({
  platnosciOpen: state.pageState.platnosciOpen,
  numerRezerwacji: state.pageState.numerRezerwacji,
  kwota: state.pageState.kwota
});

export default connect(mapStateToProps)(withStyles(styles)(NotifierOptions));